import React, { useState } from 'react';
import Viewer from 'react-viewer';

interface ImageViewerProps {
  images: any
}
const ImageViewer: React.FC<ImageViewerProps> = ({
  images
}) => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div> 
      <img src={require("../assets/image/icon20.png")}
        onClick={() => setVisible(true)}
        alt="" className='w-[20px] cursor-pointer' />
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        images={images}
        activeIndex={activeIndex}
        onChange={(_, index) => setActiveIndex(index)}
        downloadable={false}
        rotatable={false}
        scalable={false}
        zoomable={false}
        attribute={false}
        disableMouseZoom={true}
        customToolbar={(toolbars) => {
          // 过滤掉重置按钮
          return toolbars.filter(toolbar => toolbar.key !== 'reset');
        }}
      />
    </div>
  );
}
export default ImageViewer;